(function () {
    const weatherContainer = document.querySelector('.section-weather__weather');
    document.addEventListener('DOMContentLoaded', () => {
        if (document.querySelector('.section-weather')) {
            fetch(PT_Ajax.ajaxurl, {
                method: 'POST',
                body: new URLSearchParams({
                    action: 'ajax-weather',
                    nextNonce: PT_Ajax.nextNonce,
                })
            }).then(response => {
                if(response.ok) {
                    return response.json();
                } else {
                    throw new Error(`Http error: ${response.status}`);
                }
            })
                .then(response => {
                    showWeather(response);
                })
                .catch(err => {
                    console.log('WEATHER API ERROR: ', err);
                    weatherContainer.style.visibility = 'hidden';
                });
        }
    })

    function showWeather(weather) {
        const temp = document.getElementById('weather-temp');
        const city = document.getElementById('weather-city');
        const wind = document.getElementById('weather-wind');
        const pressure = document.getElementById('weather-pressure');
        const icon = document.getElementById('weather-icon');

        temp.innerText = String(Math.floor(parseInt(weather.main.temp)));
        city.innerText = weather.name;
        wind.innerText = String(Math.floor(parseInt(weather.wind.speed))) + 'km/h';
        pressure.innerText = String(Math.floor(parseInt(weather.main.pressure))) + 'hPa';

        switch (weather.weather[0].main) {
            case 'Rain':
                icon.classList.add('section-weather__icon--rain')
                break;
            case 'Clear':
                icon.classList.add('section-weather__icon--clear-sky')
                break;
            case 'Snow':
                icon.classList.add('section-weather__icon--snow')
                break;
            case 'Clouds':
                icon.classList.add('section-weather__icon--broken-clouds')
                break;
            case 'Thunderstorm':
                icon.classList.add('section-weather__icon--thunderstorm')
                break;
            case 'Mist':
                icon.classList.add('section-weather__icon--thunderstorm')
                break;
            default:
                icon.style.backgroundImage = 'url("http://openweathermap.org/img/wn/' + weather.weather[0].main.icon +'@2x.png")';
                break;
        }

        weatherContainer.classList.remove('loader');
    }
})();